const backgroundImage = {
  "gradient-calm": "linear-gradient(98.81deg, #FAF1FF 1.69%, #FFEAF4 49.21%, #E5F4FD 103.66%)",
  "gradient-colorful":
    "linear-gradient(248.06deg, #FFE5F2 12.66%, #E3F6C6 48.44%, #FFF899 121.71%)",
  "gradient-informative": "linear-gradient(68.08deg, #EBF7FF 17.43%, #DAEFFF 84.55%)",
  "gradient-delightful":
    "linear-gradient(68.91deg, #ECFFBF -31.3%, #DFF4E4 58.92%, #E1ECFA 102.06%)",
  "gradient-neutral": "linear-gradient(112.97deg, #FFFFFF 3.2%, #FBFBF6 45.79%, #F3F3F3 101.23%)",
  "gradient-account-switcher-overlay":
    "linear-gradient(90deg, rgb(23 23 23 / 0), rgb(23 23 23 / 0) 271px, rgb(23 23 23 / 0.6) 272px, rgb(23 23 23 / 0.6))",
}

module.exports = {
  backgroundImage,
}

exports.default = backgroundImage
